'use es6';

import PropTypes from 'prop-types';
import Immutable from 'immutable';
import I18n from 'I18n';
import { NavMarker } from 'react-rhumb';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UIImage from 'UIComponents/image/UIImage';
import UIDropZone from 'UIComponents/drop/UIDropZone';
import UploadFilesButton from './UploadFilesButton';
import imageUrl from 'bender-url!FileManagerImages/images/empty-folder.svg';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function EmptyFolder(props) {
  const {
    currentFolder,
    isArchivedFilterApplied
  } = props;
  return /*#__PURE__*/_jsx(UIDropZone, {
    className: "empty-folder",
    "data-test-id": "empty-folder-container",
    children: /*#__PURE__*/_jsxs("div", {
      className: "empty-folder--inner",
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "EMPTY_FOLDER"
      }), /*#__PURE__*/_jsx(UIImage, {
        className: "m-y-10",
        width: 100,
        src: imageUrl,
        responsive: false
      }), /*#__PURE__*/_jsx("h4", {
        children: isArchivedFilterApplied ? I18n.text('FileManagerDashboard.emptyFolder.archivedViewmessage') : I18n.text('FileManagerDashboard.emptyFolder.message')
      }), !isArchivedFilterApplied && /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "FileManagerDashboard.emptyFolder.hint",
          options: {
            button: /*#__PURE__*/_jsx(UploadFilesButton, {
              currentFolder: currentFolder,
              use: "link",
              children: I18n.text('FileManagerDashboard.emptyFolder.inlineButtonText')
            })
          }
        })
      })]
    })
  });
}
EmptyFolder.propTypes = {
  currentFolder: PropTypes.instanceOf(Immutable.Map),
  isArchivedFilterApplied: PropTypes.bool.isRequired
};